import { setPublicationsInProgressInitState } from './InitState';
import CURSE_INSTANCE_ACTIONS from '../../../Actions/ActionTypes';
import { IAction } from '../../../../../__core/Interfaces/IAction';

export const setPublicationsInProgressReducer = (
  state: Array<string> = setPublicationsInProgressInitState,
  action: IAction<string>
): Array<string> => {
  switch (action.type) {
    case CURSE_INSTANCE_ACTIONS.SET_PUBLICATION_START:
      return [...state, action.payload];

    case CURSE_INSTANCE_ACTIONS.SET_PUBLICATION_FINISH:
      return [...state.filter((value) => value !== action.payload)];

    default:
      return state;
  }
};
